import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Input, Panel, SegmentedControl } from '@usacow/ds';
import { api, type ClassRow } from '../../lib/api';

export function CoachClasses() {
  const [classes, setClasses] = useState<ClassRow[] | null>(null);
  const [name, setName] = useState('');
  const [division, setDivision] = useState('silver');
  const [creating, setCreating] = useState(false);

  async function load() {
    const r = await api.coachClasses();
    setClasses(r.classes);
  }
  useEffect(() => {
    void load();
  }, []);

  async function create() {
    if (!name.trim()) return;
    setCreating(true);
    await api.coachCreateClass(name.trim(), division).catch(() => {});
    setName('');
    await load();
    setCreating(false);
  }

  return (
    <div className="scr">
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">classroom</div>
          <h1 className="scr-h">Your classes</h1>
        </div>
      </div>

      <Panel title="Create a class" style={{ marginBottom: 18 }}>
        <div className="coach-create">
          <Input
            label="Class name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Silver cohort A"
          />
          <div>
            <div className="uc-field__label" style={{ marginBottom: 5 }}>
              Division
            </div>
            <SegmentedControl
              subtle
              value={division}
              onChange={setDivision}
              options={[
                { value: 'bronze', label: 'Bronze' },
                { value: 'silver', label: 'Silver' },
                { value: 'gold', label: 'Gold' },
                { value: 'platinum', label: 'Platinum' },
              ]}
            />
          </div>
          <Button variant="primary" loading={creating} onClick={create}>
            Create
          </Button>
        </div>
      </Panel>

      {!classes ? (
        <div className="dim">Loading…</div>
      ) : classes.length === 0 ? (
        <p className="dim">No classes yet. Create one, then share its join code with students.</p>
      ) : (
        <div className="coach-classlist">
          {classes.map((c) => (
            <Link key={c.id} to={`/coach/class/${c.id}`} className="coach-classcard">
              <div className="coach-classcard__top">
                <span className="coach-classcard__nm">{c.name}</span>
                {c.division && (
                  <Badge tone={c.division as never} dot>
                    {c.division[0]!.toUpperCase() + c.division.slice(1)}
                  </Badge>
                )}
              </div>
              <div className="coach-classcard__code mono">
                join code: <b>{c.join_code}</b>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
